import { serializedTypes } from '@/reports/types';
import { DateUtil } from '@/utils/index';

export const getFormattedDate = (deed: serializedTypes.SerializedDeed) => {
  const dateObject = deed.transfer?.recorder?.date;
  const dateParser = new DateUtil();

  if (dateObject?.full) {
    return dateParser.parseDateFromString(dateObject.full as string, 'DD');
  }

  if (dateObject?.parsed) {
    const { year, month, day } = dateObject.parsed;
    const formattedDate = dateParser.parseDateFromString(
      `${year} ${month} ${day}`,
      'DD',
      'yyyy L d'
    );

    return formattedDate;
  }
};
